import React, { useEffect, useRef } from "react";
import SeoHead from '../component/SeoHead';
import metaData from '../data/Meta.json';
import { jsonLdByPath } from '../data/SchemaTag.js';

export async function getServerSideProps(context) {
    const path = context.resolvedUrl.toLowerCase();

    const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

    const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

    const title = matchedMeta?.title || 'Millance';
    const description = matchedMeta?.description || 'Trade smarter with Millance.';
    const url = matchedMeta?.url || `https://millance.com${path}`;
    const jsonLd = pageJson || null;

    return {
        props: { meta: { title, description, url }, jsonLd, }
    };
}

const Forex_profit_calculator = ({ meta, jsonLd }) => {
const profitcalc = useRef(null);

  useEffect(() => {
    function RemoteCalc(WidgetConfig) {
      const ifrm = document.createElement("iframe");
      ifrm.setAttribute("calc-id", "ifrm-cbf-" + WidgetConfig.ContainerId);
      ifrm.setAttribute("scrolling", "no");
      ifrm.setAttribute("widgetType", "calculator");
      ifrm.setAttribute(
        "style",
        "width:100%; border: 0;  height:100%; min-height:620px"
      );

      let frameSrc = WidgetConfig.Url;
      if (WidgetConfig.Lang !== undefined) {
        if (
          WidgetConfig.Lang === "page" &&
          document.documentElement.lang !== ""
        ) {
          frameSrc += "/" + document.documentElement.lang;
        } else if (WidgetConfig.Lang !== "page") {
          frameSrc += "/" + WidgetConfig.Lang;
        }
      }

      frameSrc += "/widgets/" + WidgetConfig.Calculator;
      frameSrc += WidgetConfig.IsDisplayTitle
        ? "?IsDisplayTitle=true"
        : "?IsDisplayTitle=false";

      const appendParam = (key, val) => {
        if (val !== undefined) frameSrc += `&${key}=${val}`;
      };

      appendParam("ShowChartLinks", WidgetConfig.IsShowChartLinks);
      appendParam("TopPaneStyle", WidgetConfig.TopPaneStyle);
      appendParam("BottomPaneStyle", WidgetConfig.BottomPaneStyle);
      appendParam("ButtonStyle", WidgetConfig.ButtonStyle);
      appendParam("TitleStyle", WidgetConfig.TitleStyle);
      appendParam("TextboxStyle", WidgetConfig.TextboxStyle);

      let width = "100%";
      if (WidgetConfig.ContainerWidth) {
        appendParam("MaxWidth", WidgetConfig.ContainerWidth);
        if (
          WidgetConfig.ContainerWidth.endsWith("px") ||
          /^[0-9]*\.?[0-9]*$/.test(WidgetConfig.ContainerWidth)
        ) {
          const parsed = parseFloat(WidgetConfig.ContainerWidth, 10);
          width = isNaN(parsed)
            ? WidgetConfig.ContainerWidth + "px"
            : parsed + 1 + "px";
        } else if (WidgetConfig.ContainerWidth.endsWith("%")) {
          width = WidgetConfig.ContainerWidth;
        }
      }

      appendParam("ContainerId", WidgetConfig.ContainerId);
      appendParam("AffiliateId", WidgetConfig.AffiliateId);
      appendParam("CompactType", WidgetConfig.CompactType);
      appendParam("DefaultCurrencyFrom", WidgetConfig.DefaultCurrencyFrom);
      appendParam("DefaultCurrencyTo", WidgetConfig.DefaultCurrencyTo);
      appendParam("HighlightColor", encodeURIComponent(WidgetConfig.HighlightColor));
      appendParam("DefaultInstrument", encodeURIComponent(WidgetConfig.DefaultInstrument));
      appendParam("DefaultExchange", encodeURIComponent(WidgetConfig.DefaultExchange));
      appendParam("DefaultBalance", WidgetConfig.DefaultBalance);
      appendParam("DefaultPeriod", WidgetConfig.DefaultPeriod);
      appendParam("DefaultGain", WidgetConfig.DefaultGain);
      appendParam("IsShowEmbedButton", WidgetConfig.IsShowEmbedButton);
      appendParam("IsShowBuyCryptoButton", WidgetConfig.IsShowBuyCryptoButton);

      ifrm.setAttribute("src", frameSrc);

      window.addEventListener("message", onRemoteCalcMessage);

      const containerDiv = document.getElementById(WidgetConfig.ContainerId);
      containerDiv.style = "position: relative; max-width: " + width + ";";
      containerDiv.innerHTML = "";
      containerDiv.appendChild(ifrm);

      ifrm.addEventListener("load", () => {
        ifrm.contentWindow.postMessage(
          {
            method: "calc-log",
            url: window.location.href,
            calc: WidgetConfig.Calculator,
            host: window.location.host,
          },
          "*"
        );
      });
    }

    function onRemoteCalcMessage(event) {
      const data = event.data;
      if (typeof window[data.func] === "function") {
        window[data.func].call(null, data);
      }
    }

    const script = document.createElement("script");
    script.src = "https://www.cashbackforex.com/Content/remote/remote-widgets.js";
    script.async = false;

    profitcalc.current.appendChild(script);

    RemoteCalc({
      Url: "https://www.cashbackforex.com",
      TopPaneStyle:
        "YmFja2dyb3VuZDogd2hpdGU7IGNvbG9yOiBibGFjazsgYm9yZGVyOiBzb2xpZCAxcHggYmxhY2s7IGJvcmRlci1ib3R0b206IG5vbmU7IA==",
      BottomPaneStyle:
        "YmFja2dyb3VuZDogd2hpdGU7IGJvcmRlcjogc29saWQgMXB4IGJsYWNrOyBjb2xvcjogYmxhY2s7",
      ButtonStyle:
        "YmFja2dyb3VuZDogb3JhbmdlOyBjb2xvcjogd2hpdGU7IGJvcmRlci1yYWRpdXM6IDIwcHg7",
      TitleStyle:
        "dGV4dC1hbGlnbjogbGVmdDsgZm9udC1zaXplOiA0MHB4OyBmb250LXdlaWdodDogNTAwOw==",
      TextboxStyle:
        "YmFja2dyb3VuZC1jb2xvcjogd2hpdGU7IGNvbG9yOiBibGFjazsgYm9yZGVyOiBzb2xpZCAxcHggI2FhYWFhYQ==",
      ContainerWidth: "900",
      DefaultInstrument: "EUR-USD",
      HighlightColor: "#ffff00",
      IsDisplayTitle: true,
      IsShowChartLinks: false,
      IsShowEmbedButton: false,
      CompactType: "large",
      Calculator: "profit-calculator",
      ContainerId: "profit-calculator-252783",
    });
  }, []);

    return (
        <>
            <SeoHead title={meta?.title} description={meta?.description} jsonLd={jsonLd} url={meta?.url} />
            <div className="container-fuild mt-2">
                <section className="mt5trade">
                    <div className="mt5cont">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-md-12 col-lg-6 ">
                                    <h1 className=" mb-2">Forex Profit Calculator</h1>
                                    <p className=" mb-3">
                                        Estimate potential profits or losses with Millance’s profit calculator. Enter trade size, currency pair, and price to simulate returns.                                    </p>
                                </div>
                                <div className="col-md-12 col-lg-6">
                                    <img
                                        src={"/images/main/profit.png"}
                                        alt="logo"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="pipcalculator">
                    <div id="profit-calculator-252783" ref={profitcalc}></div>
                </div>
            </div>
        </>
    );
};

export default Forex_profit_calculator;

